'use client';

/**
 * Тема публичного сайта. Дефолт — СВЕТЛАЯ (палитра homepage, §2 REDESIGN_SPEC).
 *
 * Единственный источник правды — `logixa_theme_choice`, и пишется он ТОЛЬКО
 * когда посетитель сам нажал переключатель. Старые ключи (`logixa_lv2_theme`,
 * `logixa_theme`) не читаются: до редизайна шапка записывала в них 'dark' на
 * каждом маунте — не по выбору пользователя, а просто потому, что тёмная была
 * дефолтом. Всякий, кто заходил на сайт раньше, до сих пор носит это 'dark' в
 * localStorage и без этой отвязки открывал бы сайт тёмным.
 */
export type PublicTheme = 'light' | 'dark';

export const THEME_CHOICE_KEY = 'logixa_theme_choice';
const LEGACY_KEYS = ['logixa_lv2_theme', 'logixa_theme'];

/** Явный выбор посетителя, иначе светлая. */
export function readTheme(): PublicTheme {
  try {
    return localStorage.getItem(THEME_CHOICE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

/** Записать выбор, применить к <html> и сообщить остальным компонентам. */
export function applyTheme(next: PublicTheme): void {
  try {
    localStorage.setItem(THEME_CHOICE_KEY, next);
    LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));
    document.documentElement.setAttribute('data-theme', next);
    window.dispatchEvent(new Event('logixa-theme-change'));
  } catch {/* private mode */}
}
